import React from "react";

const UpdateFormProposalType = React.createContext();
UpdateFormProposalType.displayName = "UpdateFormProposalType";

export default UpdateFormProposalType;
